import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';

class KLAList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: false,
    };
    autoBind(this);

    if (this.props.hasLabel) {
      this.state.hasLabel = this.props.hasLabel;
    }
  }

  onKLAChanged(e) {
    if (this.props.parent.onKLAChanged) {
      this.props.parent.onKLAChanged(e);
    }
  }

  render() {
    return (
      <FormControl>
        <If condition={this.state.hasLabel}>
          <Then>
            <InputLabel>KLA</InputLabel>
          </Then>
        </If>
        <Select
          value={this.props.kla}
          onChange={this.onKLAChanged}
        >
          <MenuItem key={0} value={0}>Select KLA</MenuItem>
          <MenuItem key={1} value={1}>Cross KLA</MenuItem>
          <MenuItem key={2} value={2}>Chinese Language</MenuItem>
          <MenuItem key={3} value={3}>English Language</MenuItem>
          <MenuItem key={4} value={4}>Mathematics</MenuItem>
          <MenuItem key={5} value={5}>Science</MenuItem>
          <MenuItem key={6} value={6}>Technology</MenuItem>
          <MenuItem key={7} value={7}>P.S.H.E.</MenuItem>
          <MenuItem key={8} value={8}>Arts</MenuItem>
          <MenuItem key={9} value={9}>P.E.</MenuItem>
        </Select>
      </FormControl>
    )
  }
}

export default KLAList;
